<template>
  <div class="main-content">
    <!-- Page Header Start -->
    <PageHeader>
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="'Products & Services'"
          :subTitleText="'The Project Spectrum Tools Review section offers an independent, third-party assessment of various cybersecurity-related platforms prepared by our cyber advisors. These reviews are vendor-agnostic and should not be interpreted as an endorsement for any product or platform. If you have questions or concerns, please contact our <a href=mailto\:support\@projectspectrum\.io>Support Team</a> for assistance.'"
        />
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Blog Grid Section Start -->
    <section class="section p-0 mt-5">
      <div id="top-container" class="container-fluid px-xs-1 px-md-5">
        <b-row>
          <b-col lg="4" xl="3" class="p-0">
          </b-col>
          <b-col lg="8" xl="9" sm="12" xs="12" class="pb-0 pb-1">
            <div class="product-title pl-2">Products & Services</div>
          </b-col>
        </b-row>
        <b-row class="m-0">
          <b-col lg="4" xl="3" sm="12" xs="12">
            <!-- <h5>Search and Filter</h5> -->
            <div class="p-3 px-4 my-2 mb-4 search-and-filter">
              <!-- Search by Name -->
              <b-form-group class="search-and-filter-title">
                <label>Search by Name:</label>
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Type and enter to search..."
                  trim
                ></b-form-input
              ></b-form-group>
              <!-- Search by Catagory -->
              <b-form-group class="search-and-filter-title">
                <label>Categories:</label>
                <b-form-select
                  v-model="searchCategory"
                  :options="optionsCategories"
                ></b-form-select>
              </b-form-group>
              <div v-if="compareArray.length > 0" class="w-100">
                <b-form-group class="search-and-filter-title">
                  <label>{{ `Products & Services Matches: (${compareArray.length})` }}</label>
                  <ul class="m-0">
                    <li class="selected-company-item mb-2" v-for="item in selectedItems" :key="item.id">
                      <v-row>
                        <v-col cols="2" class="pr-0 pb-0">
                          <div class="remove-selected-item" @click="moreButtonSelection(item.id)">X</div>
                        </v-col>
                        <v-col cols="10" class="pl-0 pb-0">
                          <div>{{ item.toolCreatedBy }}</div>
                        </v-col>
                      </v-row>
                    </li>
                  </ul>
                </b-form-group>
                <b-form-group class="d-flex justify-content-center">
                  <router-link
                    :to="{ name: 'tool-compare', query: { ids: compareArray } }"
                  >
                    <b-button
                      id="input-1"
                      key=""
                      class="btn-compare-selected"
                      size="sm"
                      :disabled="compareArray.length < 2"
                      >Compare Products & Services</b-button
                    >
                  </router-link>
                </b-form-group>
                <b-form-group class="d-flex justify-content-center">
                  <b-button
                    id="input-2"
                    key=""
                    class="btn-compare-selected"
                    size="sm"
                    @click="deselectAllCompareCheckboxes"
                    >Clear All</b-button
                  >
                </b-form-group>
              </div>
            </div>
          </b-col>

          <b-col lg="8" xl="9" sm="12" xs="12">
            <div>
              <h5 class="text-center text-md-left text-lg-left text-xl-left">Products & Services Listing</h5>
              <p class="paragraph-statement text-center text-md-left text-lg-left text-xl-left my-3">Select up to 6 tools to compare, matches can be found on the left hand side filter</p>
            </div>
            <!-- Tool Table -->
            <b-table
              v-if="(itemsFromSearchQuery.length > 0) || isLoading"
              id="tool-table"
              :fields="fields"
              :items="itemsFromSearchQuery"
              :busy="isLoading"
              thead-class="table-header"
              tbody-class="table-body"
              responsive
              sort-icon-left
              class="mt-3"
              outlined
              hover
              sticky-header
            >
              <!-- Busy Spinner -->
              <template #table-busy>
                <div class="text-center text-secondary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="pl-2">Loading...</strong>
                </div>
              </template>
              <!-- See Checkbox -->
              <template #cell(compare)="data">
                <b-form-checkbox 
                  size="lg"
                  v-model="form.checkbox[data.item.id]"
                  @change="moreButtonSelection(data.item.id)"
                  :checked="compareArray.includes(data.item.id)"
                  :value="true"
                  :unchecked-value="false"
                />
              </template>
              <!-- Main Column with Image -->
              <template #cell(toolCreatedBy)="data">
                <div class="image-and-tool d-flex">
                  <div>
                    <b-img
                      :src="data.item.mainImage"
                      class="tool-icon"
                      rounded
                      alt="Rounded image"
                    ></b-img>
                  </div>
                  <p class="clipped-text m-0">{{ data.item.toolCreatedBy }}</p>
                </div>
              </template>
              <!-- See More Button -->
              <template #cell(more)="data">
                <div class="image-and-tool d-flex">
                  <router-link
                    :to="{ name: 'tool-details', query: { id: data.item.id } }"
                  >
                    <b-button class="btn-more" size="lg"
                      >Read More</b-button
                    >
                  </router-link>
                </div>
              </template>
            </b-table>
            <div v-else class="empty-items w-100 d-flex flex-row justify-content-center align-items-center text-center">
              <span>There are no Products available for the search query.</span>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>
    <!-- Blog Grid Section End -->

    <!-- Start Modals For Display -->
    <ModalWidget
      id="modal-product-issues"
      title="Selected Matches Limit Reached"
      centered
      hideFooter
    >
      <p slot="body" class="modal-paragraph text-center px-5">
        User Cannot select more than 6 product matches
      </p>
      <v-row slot="row-buttons">
        <v-col lg="6" xl="6" cols="12" class="d-flex flex-row justify-content-lg-start justify-content-xl-start justify-content-center">
          <router-link
              :to="{ name: 'tool-compare', query: { ids: compareArray } }"
          >
            <b-button
              id="input-3"
              key=""
              class="btn-compare-selected"
              size="sm"
              >Compare All
            </b-button>
          </router-link>
        </v-col>

        <v-col lg="6" xl="6" cols="12" class="d-flex flex-row justify-content-lg-end justify-content-xl-end justify-content-center">
          <b-button
            id="input-3"
            key=""
            class="btn-compare-selected"
            size="sm"
            @click="deselectAllCompareCheckboxes"
            >Deselect All
          </b-button>
        </v-col>
      </v-row>
    </ModalWidget>
    <!-- End Modals For Display -->
  </div>
</template>
<script>
import axios from 'axios';
import { BPagination, BFormInput } from 'bootstrap-vue';
import PageHeader from "../library/widgets/page-header.vue";
import PageHeaderTitleContent from '../library/widgets/page-header-title-content.vue';
import TitleTextContent from '../library/widgets/title-text-content.vue';
import ModalWidget from '../library/widgets/modal-widget.vue';
import { EventBus } from "../../utils/eventBus";
export default {
  name: 'tool-reviews',
  components: {
    BPagination,
    BFormInput,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
    ModalWidget,
  },
  props: {
    query: String,
  },
  data() {
    return {
      isLoading: false,
      items: [],
      itemCount: 0,
      currentPage: 1,
      perPage: 6,
      // Search
      searchQuery: this.query,
      searchCategory: null,
      searchCreatedBy: null,
      searchPriceRange: null,
      optionsCategories: [{ value: null, text: 'Search All' }],
      optionsCreatedBy: [{ value: null, text: 'Search All' }],
      optionsPriceRanges: [{ value: null, text: 'Search All' }],
      searchPaidFree: ['paid', 'free'],
      // Compare
      compareArray: [],
      // Table
      fields: [
        {
          key: 'compare',
          label: ' ',
          tdClass: 'align-middle',
        },
        {
          key: 'toolCreatedBy',
          label: 'Company',
          tdClass: 'align-middle',
          sortable: true,
        },
        {
          key: 'toolCategory',
          label: 'Category',
          tdClass: 'align-middle',
          sortable: true,
        },
        {
          key: 'more',
          label: 'Details',
          tdClass: 'align-middle',
        },
      ],
      form: {
        checkbox: {},
      }
    };
  },
  computed: {
    itemsFromSearchQuery() {
      var filteredItems = this.items;
      // Name Search (Titlte and Creator)
      if (this.searchQuery) {
        filteredItems = filteredItems.filter((item) => {
          return this.searchQuery
            .toLowerCase()
            .split(' ')
            .every(
              (v) =>
                item.toolCreatedBy?.toLowerCase().includes(v)
            );
        });
      }
      // Catagory Search
      if (this.searchCategory) {
        filteredItems = filteredItems.filter((item) => {
          return this.searchCategory.includes(item.toolCategory);
        });
      }
      return filteredItems;
    },
    selectedItems() {
      const selectedItems = this.compareArray.map(itemId => {
        const { id, toolCreatedBy } = this.items.find(item => item.id === itemId);
        return { id, toolCreatedBy };
      });
      return selectedItems;
    },
  },
  mounted: async function () {
    this.init();
      this.getToolReviews(); // async
  },
  methods: {
    init() {
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
      EventBus.$emit("activate-indicated-menu-item", "Resources");
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },

    async getToolReviews() {
      /*  API call to server: GET /api/resources/blogs  */
      this.isLoading = true;
      axios
        .get('/api/resources/toolReviews')
        .then(async (response) => {
          //console.log('Useful Tools', response.data.Items);
          this.items = response.data.Items;
          this.populateSearchCatagories();
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async populateSearchCatagories() {
      // Populate Search Options
      const uniqueCatagories = [
        ...new Set(this.items.map((item) => item.toolCategory)),
      ];
      const uniqueCreatedBy = [
        ...new Set(this.items.map((item) => item.toolCreatedBy)),
      ];
      const uniquePrice = [
        ...new Set(this.items.map((item) => item.toolPriceRange)),
      ];

      uniqueCatagories.sort();
      uniqueCreatedBy.sort();
      uniquePrice.sort();

      this.optionsCategories = await Promise.all(
        uniqueCatagories.map(async (item) => {
          return { value: item, text: item };
        })
      );
      this.optionsCreatedBy = await Promise.all(
        uniqueCreatedBy.map(async (item) => {
          return { value: item, text: item };
        })
      );
      this.optionsPriceRanges = await Promise.all(
        uniquePrice.map(async (item) => {
          return { value: item, text: item };
        })
      );

      this.optionsCategories.unshift({ value: null, text: 'Search All' });
      this.optionsCreatedBy.unshift({ value: null, text: 'Search All' });
      this.optionsPriceRanges.unshift({ value: null, text: 'Search All' });

      //console.log('Categories', this.optionsCategories);
    },
    pageClicked() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      // document.getElementById('tool-table').scrollIntoView();
    },
    moreButtonSelection(id) {
      if (this.compareArray.includes(id)) {
        this.compareArray = this.compareArray.filter(toolId => toolId !== id);
        this.$set(this.form.checkbox, id, false);
      } else {
        this.compareArray = [ ...this.compareArray, id ];

        if((this.compareArray.length <= 6) && (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs)) {
          document
            .getElementById("top-container")
            .scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
      if(this.compareArray.length > 6) {
        this.compareArray = this.compareArray.slice(0, -1);
        this.$set(this.form.checkbox, id, false);
        this.$bvModal.show('modal-product-issues');
        return;
      }
    },
    deselectAllCompareCheckboxes() {
      this.compareArray = [];
      this.form.checkbox = {};
      this.$bvModal.hide('modal-product-issues');
    },
    activateSigninRegisterMenuItem() {
      EventBus.$emit("activate-indicated-menu-item", "Sign In/Register");
    },
  },
};
</script>
<style scoped>
  .product-title {
    color: #22449D;
    font-family: Rajdhani;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .paragraph-statement {
    color: #000;
    font-family: Rajdhani;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .search-and-filter {
    border-radius: 10px;
    background: #D5D7D7;
  }
  .search-and-filter-title label, .modal-paragraph {
    color: #272727;
    font-family: Rajdhani;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
    margin-bottom: 5px;
  }

  .selected-company-item {
    color: #272727;
    font-family: Rajdhani;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    list-style-type: none;
  }
  .remove-selected-item {
    color: #424EC4;
    font-family: Rajdhani;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 23px;
    cursor: pointer;
    width: 30px;
  }

  .empty-items {
    height: 200px; 
    font-size: 22px; 
    font-weight: 600;
  }

  /* /deep/ .custom-control-input:checked, /deep/ .custom-control-label::before {
    color: blue !important;
  } */

  /* /deep/ .custom-control-label:after{ 
    border-radius: 6px;
    background-color:#D9D9D9;
  } */

  :deep h5.modal-title {
    font-size: 22px !important;
    text-align: center;
  }

  :deep .table-body > tr {
    border-top: 2px solid lightgray;
  }

  :deep .b-table-sticky-header {
    border: 3px solid #000000;
    height: 460px;
    max-height: 460px !important;
  }

  :deep .b-table-sticky-header > .table.b-table > thead > tr > th {
    position: sticky !important;
    top: -1px;
  }

  :deep .b-table-sticky-header th.table-b-table-default.position-relative, 
  :deep .b-table-sticky-header th.table-b-table-default {
    border-bottom: 3px solid #000000;
    background-color: #D5D7D7 !important;
  }

.inner-header-bg {
  background-image: url('~@/assets/images/headers/courses.png');
  background-position: center center;
}
#blog-pagination li {
  margin: 0px;
}

.tool-icon {
  object-fit: contain;
  height: 40px;
  width: 70px;
  margin-right: 10px;
}

.image-and-tool {
  max-width: 325px;
  align-items: center;
}

.clipped-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.form-control {
  height: auto;
}

.btn-compare-selected {
  width: 220px;
  height: 44px;
  padding: 10px 0px;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  border-radius: 50px;
  background-color: #424EC4;
}

.btn-more {
  width: 138px;
  height: 44px;
  padding: 10px 20px;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  background-color: #424EC4;
}

.btn-compare {
  width: 100px;
  height: auto;
  padding: 0.25rem 0.5rem;
}

@media (hover: none) {
  .btn-outline-secondary.btn-compare:hover {
    color: #6c757d;
    border-color: #6c757d;
    background: white;
  }
}
</style>
